export interface CourseOption {
  id: string;
  label: string;
  description: string;
  icon?: string;
  available: boolean;
}

export const CS_COURSES: CourseOption[] = [
  {
    id: "python",
    label: "Python",
    description: "Variables, Loops, Functions, OOP basics",
    available: true,
  },
  {
    id: "javascript",
    label: "JavaScript",
    description: "DOM, ES6+, Async programming, Arrays",
    available: true,
  },
];

